













import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false,
      running: false,
      showMessage: false,
    };
  },
  methods: {
    async exec() {
      if (!this.advertisement) {
        return;
      }
      this.running = true;
      try {
        const res = await this.$store.dispatch("post", [
          this.advertisement["@id"] + "/sync",
          this.advertisement
        ]);
        if (!res.res || res.res.ok) {
          this.$emit("success");
          this.showMessage = true;
          await new Promise(resolve => setTimeout(resolve, 3000));
          this.showMessage = false;
        }
      } finally {
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.running = false;
      }
    }
  },
  computed: {
    disabled(): boolean {
      return this.running;
    }
  }
});
